module.exports = __webpack_public_path__ + "media/images/menu-icons/articles-f398060b56acb531c4f6f08c949c8b8b.svg";